import React, { useContext } from "react";
import { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import { Image } from "react-bootstrap";
import logo from "../assets/images/samagra-logo.png";
// import ecoclub from "../assets/images/ecoclub-logo.png";
  import ecoclub from "../assets/images/Logo-2.png";
import MenuOpen from "../assets/images/bars.png";
import MOE from "../assets/images/schoolEdu-logo.png";
import { TbLogin2 } from "react-icons/tb";
import { House } from "phosphor-react";
import pmshreelogo from "../assets/images/pmshree-logo.png"
import AdminLoginModel from "./Authentication/AdminLoginModel";
import SchoolLoginModel from "./Authentication/SchoolLoginModel.jsx";
import FacultyLoginModel from "./Authentication/FacultyLoginModel.jsx";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../context";
import { BsInfoCircle } from "react-icons/bs";
import { PiTarget } from "react-icons/pi";
import { MdOutlineLibraryBooks } from "react-icons/md";
import { TbSocial } from "react-icons/tb";
import {PiUsersThreeLight} from "react-icons/pi";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
// import ecoclub from "../assets/images/ecoclub-logo.png";
import { userLoggedOut } from "../redux/auth/authSlice";
import { useLocation } from 'react-router-dom';






function Header() {
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [authCategory, setAuthCategory] = useState(0);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loginRole, setLoginRole] = useState(null);
  const handleClose = () => { setIsClick(false); setShow(false) };
  const handleClose2 = () => setShow2(false);
  const userData = useSelector(state => state.auth.user);
  const dispatch=useDispatch()
  const location = useLocation();


  const [isClick, setIsClick] = useState(false);
  const [role, setRole] = useState(null);
  const handleShow = () => setShow(true);
  // const handleShow2 = () => setShow2(true);
  const [manu, setMenu] = useState(false);
  const [showHeader, setShowHeader] = useState(false);
  const [showHeader2, setShowHeader2] = useState(false);
  const { setSectionId } = useContext(AppContext);
  const navigate = useNavigate();
  const menuHandle = () => {
    setMenu(!manu);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const [showLoginDropdown, setShowLoginDropdown] = useState(false);

  const handleSelectLogin = (selectedRole) => {
    setRole(selectedRole); // Set the role to show the respective login modal
    setIsClick(true);
    setShowLoginDropdown(false); // Close the dropdown when a login option is selected
  };

  
  

  

  const handleHomeButton = () => {
    console.log(loginRole,"loginRole");
    if (loginRole === 2) {
      navigate("/school");
      ;
    }else if(loginRole === 3){
      navigate("/faculty");
    }
    else if(loginRole === 1){
      navigate("/Ekpedmaakenaam");
    }
     else  {
      navigate("/admin/environment-day-dashboard");
      ;
    }  
  }

  useEffect(() => {
    // Check if a user is already logged in by checking the token
    const token = localStorage.getItem("token");
    if (token) {
      const decodedToken = jwtDecode(token);
      setIsLoggedIn(true);
      setLoginRole(decodedToken.role);
    }
  }, []);
  const scrollToSection = (sectionId) => {
    setSectionId(sectionId); // Store the section ID in context
    navigate('/'); // Navigate to eco-club
    // Add a timeout to allow the page to load before scrolling
    setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    }, 100); // Adjust the timeout as necessary
  };

  return (
    <div className="mainTopDiv">
      <header>
        <div className="row py-1 animate__animated animate__fadeInDown">
          <div className="logo-sec col-6 col-lg-9 text-start d-flex justify-content-between align-items-center">
            <Link to="/" title="" className="logo-eco">
              <Image src={ecoclub} alt="Logo" width="320px" />
            </Link>
            
            <Link
              to="https://www.education.gov.in/"
              className="logo-moe"
              title=""
              target="_blank"
            >
              <Image src={MOE} alt="Logo" width={348} />
            </Link>
            <Link
              to="https://samagra.education.gov.in/"
              className="logo-dept"
              title=""
              target="_blank"
            >
              <Image src={logo} alt="Logo" width={240} />
            </Link>
            <Link
              to="https://pmshrischools.education.gov.in/"
              className="logo-moe"
              title=""
              target="_blank"
            >
              <Image src={pmshreelogo} alt="Logo" width={158} />
            </Link>
            
          </div>

          
        </div>

        <Link
          className="menu-mobile-button"
          to={undefined}
          onClick={menuHandle}
        >
          <Image src={MenuOpen} alt="Menu" />
        </Link>
        <nav className={manu ? "navbars mobile open animate__animated animate__fadeInUp":"navbars animate__animated animate__fadeInUp"}>
          <ul className="d-flex justify-content-center pl-5">
            <li>
              <a href="#" onClick={() => scrollToSection('themes')}>
                <span><House size={30} /></span> Themes
              </a>
            </li>
            <li>
              <a href="#" onClick={() => scrollToSection('aboutEcoClubs')}>
              <BsInfoCircle size={22}/> About Eco Clubs For Mission LiFE
              </a>
            </li>
            <li>
              <a href="#" onClick={() => scrollToSection('objectivesGoals')}>
              <PiTarget size={24}/> Objectives & Goals
              </a>
            </li>
            <li>
              <a href="#" onClick={() => scrollToSection('publications')}>
              <MdOutlineLibraryBooks size={20}/> Publications
              </a>
            </li>
            <li>
              <a href="#" onClick={() => scrollToSection('getSocial')}>
              <PiUsersThreeLight size={20}/> Let's Get Social
              </a>
            </li>
            <li>
              <a href="#" onClick={() => scrollToSection('stakeholders')}>
              <TbSocial size={20}/>Stakeholders involved
              </a>
            </li>
          </ul>
        </nav>
      </header>
      {isClick && (
        <>
          {role === "school" && <SchoolLoginModel handleViewexit={handleClose} />}
          {role === "faculty" && <FacultyLoginModel handleViewexit={handleClose} />}
          {role === "admin" && <AdminLoginModel handleViewexit={handleClose} />}
        </>
      )}
    </div>
  );
}

export default Header;
